export const addCourseEnrolleeToEnrollees = (courseId, userId) => (courseEnrollees = []) => {
    //  Remove student
    const enrollees = courseEnrollees.filter(ce => ce.userId !== userId);

    //  Add potential course
    if (courseId && userId) {
        enrollees.push({ courseId, userId });
    }
    return enrollees;
};